import { useMutation } from 'react-query';
import {
  createScene,
  type CreateSceneBody,
  type CreateSceneResponse
} from '../../services/sceneService';

export function useCreateScene() {
  return useMutation<CreateSceneResponse, Error, CreateSceneBody>((body) => createScene(body));
}
